import { objects } from '../../../../utils'

/**
 * Fixes alerts with font awesome icons in them as well as other issues.
 *
 * @param   {Object} alert The alert object.
 * @returns {Object}       The alert object.
 */
export const formatAlert = alert => {
	const icons = [
		{ icon: 'svg-exclamation-triangle', string: '<i class="fa fa-exclamation-triangle"></i>' },
		{ icon: 'svg-flag', string: '<i class="fa fa-flag"></i>' }
	]

	icons.forEach(icon => {
		if (-1 !== alert.message.indexOf(icon.string)) {
			alert.message = alert.message.replace(icon.string, '')
			alert.icon    = icon.icon
		}
	})

	// Fix the type of alert.
	if ('reactivate-subscription-notice' === alert.type) {
		alert.type = 'error'
	}

	if (alert.icon && 0 !== alert.icon.indexOf('svg-')) {
		alert.icon = 'svg-' + alert.icon
	}

	return alert
}

export const getErrorMessage = (payload) => {
	let { message, response, explanation, status } = payload;
	let msg = explanation || 'Something went wrong while fetching data.'
	if (response && response.body) {
		let { code, message, error } = response.body

		msg += ' Reported error:<br>'
		if (code) {
			msg += `[${code}] `
		}
		msg += `${error && true !== error ? `<pre>${error}</pre>` : message}`

		if (response.body.status) {
			status = response.body.status
		}
	} else if (message) {
		msg += ' ' + message
	}

	if (status) {
		msg += ` (status: ${status})`
	}

	return msg;
}

export const getErrorAlert = (payload) => ({
	icon    : 'svg-exclamation-triangle',
	type    : 'error',
	closes  : Boolean(payload.closes),
	message : getErrorMessage(payload),
	meta    : payload.meta || {},
})

const hasAlert = (state, payload) => {
	return -1 !== state.alerts.findIndex(a => {
		return objects.areEqual(a, payload);
	})
}

const addError = (state, payload) => {
	state.alerts.push(getErrorAlert(payload))
}

export default {
	addError,
	setError (state, payload) {
		addError(state, payload)
		state.error = true
	},
	maybeAddError (state, payload) {
		const errorAlert = getErrorAlert(payload)
		if (hasAlert(state, errorAlert)) {
			return false
		}

		addError(state, payload)
	},
	setAlerts (state, payload) {
		state.alerts = payload.map(formatAlert)
	},
	addAlert (state, payload) {
		const alerts = [...state.alerts]

		// Add the alert to the top.
		// If we want to add it to the bottom, change this to alerts.push(payload).
		alerts.unshift(payload)

		this._vm.$set(state, 'alerts', alerts)
	},
	maybeAddAlert (state, payload) {
		if (hasAlert(state, payload)) {
			return false
		}

		const alerts = [...state.alerts]

		// Add the alert to the top.
		// If we want to add it to the bottom, change this to alerts.push(payload).
		alerts.unshift(payload)

		this._vm.$set(state, 'alerts', alerts)
	},
	updateAlert (state, { index, alert }) {
		this._vm.$set(state.alerts, index, alert)
	},
	closeAlert (state, index) {
		this._vm.$delete(state.alerts, index)
	},
	closeAlerts (state) {
		state.alerts = []
	},
	clearAlerts (state) {
		state.alerts = []
		state.error = false
	}
}
